export default function AccidentalSimple() {
  return (
    <section className="tw-py-20 tw-bg-white">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-6">
        {/* Title Section */}
        <div className="tw-text-center tw-mb-12">
          <h2 
            className="tw-text-4xl md:tw-text-[56px] tw-font-medium tw-text-black tw-mb-6 tw-leading-tight"
            style={{ fontFamily: "'Instrument Serif', serif" }}
          >
            Protection made simple, coverage made strong
          </h2>
          
          {/* Subtext with Checkmark */}
          <div className="tw-flex tw-items-start tw-justify-center tw-gap-3 tw-max-w-3xl tw-mx-auto">
            <div className="tw-mt-1 tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6">
              <svg 
                width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" 
                className="tw-text-black"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <p 
              className="tw-text-gray-700 tw-text-lg md:tw-text-[22px] tw-text-left tw-leading-relaxed"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              <span className="tw-font-semibold tw-text-black">Accidental Damage Coverage:</span> From the date of plan purchase, your furniture is protected against spills, scratches, impacts, and pet damage.
            </p>
          </div>
        </div>

        {/* Hero Image */}
        <div className="tw-w-full tw-overflow-hidden tw-rounded-[32px] tw-bg-gray-50">
          <img 
            src="/nestroot/nestroot-simple-protection.png" 
            alt="Nestroots Modern Furniture" 
            className="tw-w-full tw-h-auto tw-object-cover"
          />
        </div>
      </div>
    </section>
  );
}
